
import Vue from "vue";

export default Vue.extend({
  name: "SignScreen",
  props: {
    setStep: {
      type: Function,
    },
    progressPercent: {
      type: Number,
    },
    progressText: {
      type: String,
    },
    signMessage: {
      type: Function,
    },
    generatePrecompute: {
      type: Function,
    },
  },
  data: () => ({
    message: "Hello MPC!!",
    signing: false,
    rules: {
      required: (value: string) => !!value || "Required.",
    },
    validForm: true,
    clients: [],
  }),
  computed: {
    isPrecomputeCompleted() {
      return this.progressPercent == 100;
    },
  },
  async mounted() {
    await this.generatePrecompute();
  },
  methods: {
    async signMessageTo() {
      this.signing = true;
      await this.signMessage(this.message);
      this.signing = false;
      this.setStep(3);
    },
  },
});
